<div class="eek2-history-view">
	<loader-overlay *ngIf="vm.loading"></loader-overlay>

	<div *ngIf="!vm.loading && vm.error" class="eek2-card eek2-empty">
		{{ copy.empty }}
	</div>

	<ng-container *ngIf="!vm.loading && !vm.error">
		<div class="eek2-card">
			<div class="eek2-header">
				<div>
					<h2 class="eek2-section-title">{{ copy.title }}</h2>
					<div *ngIf="vm.dateText" class="eek2-meta">{{ copy.viewing }}: {{ vm.dateText }}</div>
				</div>
				<button type="button" class="eek2-btn secondary" (click)="backToResults()">{{ copy.backToResults }}</button>
			</div>

			<div *ngIf="!vm.tableRows.length" class="eek2-empty">{{ copy.empty }}</div>

			<div *ngIf="vm.tableRows.length" class="eek2-table-scroll">
				<table class="eek2-table">
					<thead>
						<tr>
							<th>{{ copy.date }}</th>
							<th *ngFor="let sub of vm.trendCards">{{ sub.code }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of vm.tableRows" [class.eek2-current]="row.id === vm.currentRecordId">
							<td>{{ row.dateText }}</td>
							<td *ngFor="let score of row.scores" [class.eek2-over]="score.above">
								{{ score.score }}<span *ngIf="score.above"> ⚑</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="eek2-card">
			<h3 class="eek2-section-title">{{ copy.trendTitle }}</h3>
			<div class="eek2-trend" *ngIf="vm.trendCards.length">
				<div class="eek2-trend-card" *ngFor="let trend of vm.trendCards">
					<h4>{{ trend.label }} <span class="eek2-trend-meta">({{ trend.code }})</span></h4>
					<div class="eek2-trend-meta">{{ trend.meta }}</div>
					<svg class="eek2-spark" viewBox="0 0 200 56" role="img" aria-label="trend">
						<line x1="4" [attr.y1]="trend.sparkline.cutoffY" x2="196" [attr.y2]="trend.sparkline.cutoffY" stroke="var(--eek2-ink)" stroke-width="1" stroke-dasharray="3 3" opacity="0.55"></line>
						<polyline *ngIf="vm.history.length > 1" [attr.points]="trend.sparkline.pathPoints" fill="none" [attr.stroke]="trend.sparkline.lineColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></polyline>
						<circle *ngFor="let dot of trend.sparkline.dots" [attr.cx]="dot.x" [attr.cy]="dot.y" r="2.6" [attr.fill]="dot.color"></circle>
					</svg>
				</div>
			</div>
		</div>
	</ng-container>
</div>
